import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';

/**
 * Route guard for everything under /app/*. While the initial Firebase
 * auth-state check is in flight, render a lightweight loading state (never
 * flash the login page for an already-signed-in seat). Once resolved, an
 * unauthenticated visitor is redirected to /login with the attempted
 * location stashed in `state.from`, so Login can send them back after a
 * successful sign-in.
 */
export default function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="aq-auth-loading" role="status" aria-live="polite">
        <span className="aq-spinner" aria-hidden="true" />
        <span>Loading…</span>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
}
